var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hl-embed-video-background-wrapper"},[(_vm.sources && _vm.sources.length)?_c('div',[_c('video-background',{style:(_vm.getStyle()),attrs:{"src":_vm.videoUrl,"sources":_vm.sources,"poster":_vm.posterUrl,"loop":true}},[_c('div',{staticClass:"content-wrapper",domProps:{"innerHTML":_vm._s(_vm.content)}})])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }